import { User } from "../gateway/User/User";

export class GetSignnUpDataUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ _id = "", accountingId = "" } = {}) {
        const payload = this.sanitizeInput({ _id, accountingId });
        if (!payload._id) return null;
        if (!payload.accountingId) return null;
        const signUpData = await this.UserGateway.getSignUpData(payload);
        return signUpData;
    }

    sanitizeInput({ _id = "", accountingId = "" } = {}) {
        const sanitizedId = String(_id).trim();
        const sanitizedAccountingId = String(accountingId).trim();
        return {
            _id: sanitizedId,
            accountingId: sanitizedAccountingId
        };
    }
}
